export default{	
	product: state => state.product,
	productView: state => state.productView,
	loading: state => state.loading,
	productsRelated: state => state.productRelated,
	loadingRelated: state => state.loadingRelated,
}